import { render } from "./CoverImageUpload.vue?vue&type=template&id=1e633fff&scoped=true"
import script from "./CoverImageUpload.vue?vue&type=script&lang=js"
export * from "./CoverImageUpload.vue?vue&type=script&lang=js"

import "./CoverImageUpload.vue?vue&type=style&index=0&id=1e633fff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e633fff"]])

export default __exports__